import React, { useContext } from 'react';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import {
  CustomerAccountNavigation,
  useAccountCrumbs,
} from '@thd-olt-component-react/customer-account-navigation';
import { QueryProvider, extend } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useInterceptors } from '../hooks/use-interceptors';
import { Alert } from '../components/shared/alert/alert';
import { PageTitle } from '../components/shared/page-title';
import { AddressesContent } from '../components/addresses/address-content/address-content';
import {
  Crumb,
  StaticCrumb,
  mapCrumbsToStaticCrumbs,
} from '../utils/breadcrumbs';

const crumbs: Crumb[] = [
  {
    label: 'Addresses',
    path: '/myaccount/addresses',
  },
];

export const Addresses = () => {
  const { redirectError } = useInterceptors();
  const { isConsumerApp } = useContext(ExperienceContext);

  const staticCrumbs: StaticCrumb[] = mapCrumbsToStaticCrumbs(
    useAccountCrumbs(crumbs),
  );

  return (
    <div className="grid isBound">
      <div className="col__12-12">
        {redirectError ? (
          <div className="sui-pt-8">
            <Alert status="info">{redirectError.message}</Alert>
          </div>
        ) : (
          <>
            <div className="sui-grid sui-gap-3 sm:sui-py-4">
              {!isConsumerApp && (
                <ErrorBoundary name="breadcrumbs">
                  <QueryProvider cacheKey="addresses-page">
                    <Breadcrumbs staticCrumbs={staticCrumbs} />
                  </QueryProvider>
                </ErrorBoundary>
              )}
              <PageTitle title="Addresses" dataTestId="addresses-title" />
            </div>
            <div className="sui-grid sui-grid-cols-12 sui-gap-5 sui-pt-2">
              <div className="sui-col-span-12 lg:sui-col-span-3">
                <ErrorBoundary name="customer-account-navigation">
                  <QueryProvider cacheKey="left-nav">
                    <CustomerAccountNavigation />
                  </QueryProvider>
                </ErrorBoundary>
              </div>

              <div className="sui-col-span-12 lg:sui-col-span-9">
                <ErrorBoundary name="addresses-content">
                  <AddressesContent />
                </ErrorBoundary>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

Addresses.displayName = 'Addresses';
Addresses.dataModel = extend(CustomerAccountNavigation, Breadcrumbs);
